import { selectById } from "state/selectors/data";

export function selectNamesAsString(store, ids) {
    const identities = selectById(store, "db.identities", ids);
    return identities.map((identity) => identity.name).join(", ");
}
